import React from 'react'
import { PropTypes } from 'prop-types'
import { useForm } from 'react-hook-form';

import auth from '../../components/common/Auth';
import { Redirect } from 'react-router-dom'

import { Card, Col, Container, Form, Row } from 'react-bootstrap';

import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import ErrorMessage from '../../components/common/ErrorMessage';

import { ButtonsSaveAndCancel } from '../../components/common/ButtonsSaveAndCancel';
import InputField from '../../components/common/InputField';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';
import { changePasswordAPI } from '../../components/apis/settingsAPI'
import { useHeaderHTTP } from '../../hook/useHeaderHTTP';

export const Password = (props, context) => {


    // Hook to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading();
    
    // const [ isLoding, setisLoding ] = useState(false);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
        defaultValues: {
                        
            new_password: "",
            confirm_new_password: "",

            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }
    });

    const { header } = useHeaderHTTP();   

    // Function calls at form submit
    const onSubmit = data => {

        showSpinner();
        
        const payload = {
            password: getValues().new_password,
        };

        // Call function to create "new" user password
        try {

            const result = changePasswordAPI(header, JSON.stringify(payload));
            console.log(result);
            // Set onSubmitOk in "true" in order to redirect to the user list after crete the new user.
            setValue("onSubmitOk",  true );
            hideSpinner();

        } catch (err) {
            // Set "backendError" show a back-end error as message to the user at the top.
            setValue("backendError",  err.message );
            hideSpinner();
        }
    };

    // If OnSubmit was success, redirect to user list
    if (getValues().onSubmitOk){
        console.log("Redirecct after correct submit!")
        return <Redirect to='/settings/user-settings' />
    }

    return <>{(isLoading)?(<Loading/>):( 

        <Container fluid>

            <ErrorMessage message={getValues().backendError}/>

            <PageHeaderStandar title={context.t('Change Password')} subtitle={context.t('Settings')} />

            <Card small="true" style={{ marginBottom: '20px'}}>
                <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px"}}>
                    <Col lg="12" >
                        <Row >

                            <InputField label={context.t('Password')} type="password" name="new_password" placeholder={context.t('********')} 
                                errors={errors} 
                                useFormRegister= {
                                    register("new_password", { 
                                    required: context.t("This is required"),
                                    pattern: {
                                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,-.\/:;<=>?\\@[\]^_`{|}~]).{6,30}$/, // eslint-disable-line 
                                        message: context.t("Password must be between 8 and 30 characters, at least one uppercase, one lowercase and one special character"),
                                    }
                                    })
                                }
                            />
                        </Row>
                        <Row >
                            <InputField label={context.t('Confirm Password')} type="password" name="confirm_new_password" placeholder={context.t('********')} 
                            errors={errors} 
                            useFormRegister= {
                                register("confirm_new_password", { 
                                required: context.t("This is required"), 
                                validate: {
                                    identicalPasswords: value => (value === getValues().new_password) || context.t("Passwords must be the same"), 
                                },
                                })
                            }
                            />
                        </Row>
                        <hr/>
                        <ButtonsSaveAndCancel context={context}/>
                    </Col>
                </Form>
            </Card>
        </Container>
    )}</>
}

Password.contextTypes = {
    t: PropTypes.func
}

export default Password;